var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrevBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16663 11.5L6.25588 9.5893C5.93044 9.26386 5.93044 8.73622 6.25588 8.41078L8.16663 6.50004M6.49996 9.00004L12.3333 9.00004M8.99996 17.3334C4.39759 17.3334 0.666626 13.6024 0.666626 9.00004C0.666626 4.39767 4.39759 0.666707 8.99996 0.666707C13.6023 0.666707 17.3333 4.39767 17.3333 9.00004C17.3333 13.6024 13.6023 17.3334 8.99996 17.3334Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevBtn);
export default __webpack_public_path__ + "static/media/prev-btn.993e509dc5450b2c0c8cb21468eb4f72.svg";
export { ForwardRef as ReactComponent };